<template>
  <div>
    <div class="header">
      <div class="container">
        <div class="title">
          안전보건 조직체계도
        </div>
      </div>
      <div class="writer">
        <div class="item">
          <span>사업장명</span>
          <span class="print-input">{{ form.stdInfo.field_name }}</span>
        </div>
        <div class="item">
          <span>작성자</span>
          <span class="print-input">{{ form.stdInfo.writer_name }}</span>
        </div>
        <div class="item">
          <span>작성일</span>
          <span class="print-input">{{ form.stdInfo.date }}</span>
        </div>

      </div>
    </div>
    <div class="body">
      <div class="container">

        <div class="col-3">
          <br>
          <div style="width: 100%; margin-left: auto; margin-right: auto">
            <div class="info-card">
              <div class="title">안전보건관리책임자</div>
              <div class="contents">
                <div class="key-value">
                  <span class="key">대표</span>
                  <span class="value">{{ form.group1[0].name }}</span>
                </div>
                <div class="phone">
                  {{ form.group1[0].phone }}
                </div>
              </div>
            </div>
            <div class="line-h" />
          </div>
          <br>
          <div class="info-card" style="width: 100%;">
            <div class="title">관리감독자</div>
            <div class="contents">
              <div class="memo2">{{ form.group1[1].name }}</div>
              <div class="memo2">{{ form.group1[1].phone }}</div>
            </div>
          </div>
          <div>
            <div style="display: grid; height: 19px;">
              <div class="line-h" style="height: 19px;"/>
              <div class="line-w" style="width: calc(100% + 42px); margin-left: -21px; margin-right: -21px;"/>
            </div>
          </div>
          <div class="info-card" style="width: 100%;">
            <div class="title">안전보건담당자</div>
            <div class="contents">
              <div class="key-value">
                <span class="key">안전담당자</span>
                <span class="value">{{ form.group1[2].name }}</span>
              </div>
              <div class="phone">
                {{ form.group1[2].phone }}
              </div>
              <div class="key-value">
                <span class="key">보건담당자</span>
                <span class="value">{{ form.group1[3].name }}</span>
              </div>
              <div class="phone">
                {{ form.group1[3].phone }}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Print126Project3',
  props: {
    board: Object,
    form: Object,
  }
}
</script>

<style lang="scss" scoped>
$border-color: #cdcdcd;
$approval-border: 2px solid #cdcdcd;
.header {
  padding-bottom: 10px;
  border-bottom: 1px solid #cdcdcd;

  & > .container {
    max-width: 100%;
    margin-bottom: 44px;
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    justify-content: center;

    & > .title {
      display: flex;
      margin: auto;
      font-weight: bold;
      font-size: 24px;
    }
    & > .approval {
      width: 240px;
      height: 100%;
      display: grid;
      grid-template-columns: auto 1fr;
      border: $approval-border;

      .title {
        width: 100%;
        min-width: 33px;
        min-height: 38px;
        display: flex;
        justify-content: center;
        background-color: #f9f9f9;
        align-items: center;
      }

      .sign-space {
        height: 100px;
      }

      & > .left { width: 32px; border-right: $approval-border}
      & > .right > .title { border-bottom: $approval-border}

    }
  }
  & > .writer {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 16px;

    & > .item {
      display: flex;
      align-items: center;

      span:nth-child(1) { width: 110px; min-width: 110px; font-weight: 500;}
      span:nth-child(2) { width: 100%; }
    }
  }
}
.body {

  & > .container {
    max-width: 100%;
    margin: 0;
    padding: 140px 0 0;

    .line-h { display: flex; margin-left: auto; margin-right: auto; width: 1px; height: 60px; background-color: $border-color }
    .line-w { display: flex; margin-top: auto; margin-bottom: auto; width: 100%; height: 1px; background-color: $border-color;}

    & > .col-3 {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      column-gap:21px;
      justify-content: center;
    }

    & > .col-5 {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      column-gap:21px;
      justify-content: center;
    }
  }

  .info-card {

    & > .title {
      grid-area: head;
      font-weight: 500;
      display: flex;
      justify-content: center;
      align-items: center;
      border: solid 1px #cdcdcd;
      background-color: #f9f9f9;
      height: 38px;
      padding: 10px;
    }

    & > .contents {
      display: block !important;
      border: solid 1px #cdcdcd;
      border-top: none;
      border-bottom: none;

      div { display: flex; align-items: center; height: 38px; border-bottom: solid 1px #cdcdcd;}
      //div:last-child {border-bottom: none;}

      & > .key-value {
        display: grid;
        grid-template-columns: auto 1fr;

        span { display: flex; align-items: center; height: 100%; padding-left: 10px;padding-right: 10px; }
        span:first-child { background-color: #f9f9f9; border-right: solid 1px #cdcdcd;}
      }

      & > .memo {
        height: 152px;
      }

      & > .phone {
        grid-area: phone;
        font-weight: 500;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 38px;
        padding: 10px;
      }
      & > .memo2 {
        display: flex;
        align-items: flex-start;
        height: 76px;
        padding: 10px;
        font-weight: 500;
      }
    }
  }
}
</style>
